var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "hero-section",
    style: _vm.mobile && !_vm.isEmpty(_vm.mobileStyle) ? _vm.mobileStyle : _vm.style
  }, [_c('Container', [_c('div', {
    staticClass: "h-full grid xl:grid-cols-2 lg:grid-cols-2 flex items-center",
    class: {
      'gap-12': _vm.imageGap
    }
  }, [_c('div', {
    staticClass: "hero-content xl:mt-16 lg:mt-16 sm-md: mb-12",
    class: {
      'lg:mt-56': _vm.imageAlign === 'bottom'
    }
  }, [_c('h1', {
    staticClass: "font-semibold mt-0 mb-6 md:xl:text-left"
  }, [_vm._v(_vm._s(_vm.heading))]), _vm._v(" "), _c('sanity-block-content', {
    staticClass: "hero-subheading",
    attrs: {
      "blocks": _vm.subheading
    }
  }), _vm._v(" "), _c('cta-btn', _vm._b({}, 'cta-btn', _vm.cta, false))], 1), _vm._v(" "), _vm.image ? _c('div', {
    staticClass: "hero-image relative w-full h-full",
    class: [_vm.heroImageClassObj, _vm.imageAlign, {
      'sm-md:hidden': _vm.showMobileImage
    }]
  }, [_c('img', _vm._b({
    staticClass: "mx-auto",
    class: [{
      'h-full w-full': _vm.imageAlign === 'stretch',
      'mx-auto w-full xl:absolute lg:absolute xl:bottom-0 lg:bottom-0': _vm.imageAlign === 'bottom'
    }],
    attrs: {
      "loading": "eager",
      "alt": _vm.image.alt
    }
  }, 'img', _vm.useAttributes(_vm.image), false))]) : _vm._e(), _vm._v(" "), _vm.showMobileImage ? _c('div', {
    ref: "mobileHeroImage",
    staticClass: "hero-image hero-image-mobile relative w-full h-full",
    class: [_vm.heroImageClassObj, 'lg:hidden xl:hidden', `${_vm.imageAlign}-mobile`]
  }, [_c('img', _vm._b({
    staticClass: "mx-auto",
    class: [{
      'h-full full-width': _vm.imageAlign === 'stretch',
      'w-full xl:absolute lg:absolute xl:bottom-0 lg:bottom-0': _vm.imageAlign === 'bottom'
    }],
    attrs: {
      "loading": "eager",
      "alt": _vm.mobileImage.alt
    }
  }, 'img', _vm.useAttributes(_vm.mobileImage), false))]) : _vm._e()]), _vm._v(" "), _vm.disclosure ? _c('sanity-block-content', {
    staticClass: "hero-disclosure",
    attrs: {
      "blocks": _vm.disclosure
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm.showBgImg ? _c('background-image', {
    class: {
      'sm-md:hidden': _vm.showMobileBgImg || !_vm.isEmpty(_vm.mobileStyle)
    },
    attrs: {
      "image": _vm.bgImg
    }
  }) : _vm._e(), _vm._v(" "), _vm.mobile && _vm.showMobileBgImg ? _c('background-image', {
    staticClass: "lg:hidden xl:hidden",
    attrs: {
      "image": _vm.mobileBgImg
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };